module.exports = __webpack_public_path__ + "img/bioscie.7716172b.png";